import React, { useEffect, useState } from "react";
import FontIcon from "react-md/lib/FontIcons";
import "../styles/expandableTableAssignedServices.css";
import Autocomplete from "@material-ui/lab/Autocomplete";
import NoRecordsIcon from "../../../../../assets/icons/no-records.png";
import { Button } from "react-md";
import filterApplied from "../../../../../assets/icons/filter-applied-icon.svg";
import funnelIcon from "../../../../../assets/icons/funnel.svg";
import goIcon from "../../../../../assets/icons/right_arrow_go_btn.svg";
import { TextField, Radio, Checkbox } from "@material-ui/core";

const ExpandableTableSelectableAssignedServices = (props) => {
  const [tableData, setTableData] = useState(props?.data?.assignedServices);
  const [selectedServiceTypeObjects, setSelectedServiceTypeObjects] = useState(
    [],
  );
  const [serviceId, setServiceId] = useState("");
  const [openFilter, setOpenFilter] = useState(false);
  const [openBackdrop, setOpenBackdrop] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setTableData(props?.data?.assignedServices);
  }, [props]);

  const STATUS_MAP = {
    Active: "active",
    Inactive: "inactive",
  };

  const stringToInt = (str) => {
    const num = parseInt(str, 10);
    return isNaN(num) ? null : num;
  };

  const isRowSelected = (id) =>
    Boolean(props?.isAllSelected) ||
    (Array.isArray(props?.selectedServiceIds) &&
      props.selectedServiceIds.includes(id));

  const getAllModesForService = (id) => {
    const fullService = (props?.data?.allAssignedServicesArray ?? []).find(
      (s) => s?.id === id,
    );
    return fullService?.serviceModeDetails ?? [];
  };

  return (
    <div className="table-container-assigned-plans">
      <table className="expandable-table">
        <thead>
          <tr>
            <th style={{ width: 40 }}>
              <Checkbox
                checked={Boolean(props?.isAllSelected)}
                onChange={(e) => {
                  if (props?.onToggleAll) {
                    props.onToggleAll(e.target.checked);
                  }
                }}
              />
            </th>
            <th>
              Service ID
              <img
                src={
                  (props?.filterObj?.ids?.length ?? 0) > 0
                    ? filterApplied
                    : funnelIcon
                }
                onClick={() => {
                  setOpenBackdrop(true);
                  setOpenFilter(2);
                }}
              />
              {openFilter === 2 && (
                <div className="filter-div-assigned-plans-table">
                  <div className="can-be-booked-for-filter">
                    <TextField
                      placeholder="Service ID"
                      type="text"
                      value={serviceId}
                      onChange={(e) => {
                        setServiceId(e.target.value);
                        if (e.target.value == "") {
                          props.setFilterObj((prev) => ({
                            ...prev,
                            ids: [],
                          }));
                        }
                      }}
                    />
                    <img
                      src={goIcon}
                      alt="Go"
                      style={{
                        width: "20px",
                        height: "20px",
                        cursor: "pointer",
                        marginBottom: "-10px",
                      }}
                      onClick={() => {
                        props.setFilterObj((prev) => ({
                          ...prev,
                          ids: [stringToInt(serviceId)],
                        }));
                      }}
                    />
                  </div>
                </div>
              )}
            </th>
            <th>
              Service type
              <img
                src={
                  (props?.filterObj?.serviceTypeIds?.length ?? 0) > 0
                    ? filterApplied
                    : funnelIcon
                }
                style={{ cursor: "pointer" }}
                onClick={() => {
                  setOpenBackdrop(true);
                  setOpenFilter(5);
                }}
              />
              {openFilter === 5 && (
                <div className="filter-div-assigned-plans-table">
                  <Autocomplete
                    style={{
                      width: "300px",
                      maxHeight: "200px",
                      overflowY: "scroll",
                      overflowX: "hidden",
                    }}
                    multiple
                    id="multiple-limit-service-type"
                    options={[
                      ...new Set(
                        (props?.data?.allAssignedServicesArray ?? [])
                          .map((option) =>
                            JSON.stringify({
                              serviceTypeName: option?.serviceTypeName,
                              serviceTypeId: option?.serviceTypeId,
                            }),
                          )
                          .filter((obj) =>
                            obj ? JSON.parse(obj)?.serviceTypeId : false,
                          ),
                      ),
                    ]}
                    getOptionLabel={(option) =>
                      option ? JSON.parse(option)?.serviceTypeName ?? "-" : "-"
                    }
                    value={selectedServiceTypeObjects ?? []}
                    onChange={(e, v) => {
                      if (v) {
                        setSelectedServiceTypeObjects(v ?? []);
                        props.setFilterObj((prev) => ({
                          ...prev,
                          serviceTypeIds: (v ?? []).map(
                            (e) => JSON.parse(e)?.serviceTypeId,
                          ),
                        }));
                      }
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        placeholder=""
                        className="autocomplete-text-field-class"
                      />
                    )}
                  />
                </div>
              )}
            </th>
            <th>
              Service code
              <img
                src={
                  (props?.filterObj?.nameMatch?.length ?? 0) > 0
                    ? filterApplied
                    : funnelIcon
                }
                style={{ cursor: "pointer" }}
                onClick={() => {
                  setOpenBackdrop(true);
                  setOpenFilter(3);
                }}
              />
              {openFilter === 3 && (
                <div className="filter-div-assigned-plans-table">
                  <Autocomplete
                    style={{
                      width: "300px",
                      maxHeight: "200px",
                      overflowY: "scroll",
                      overflowX: "hidden",
                    }}
                    multiple
                    id="multiple-limit-service-code"
                    options={(props?.data?.allAssignedServicesArray ?? [])
                      .map((option) => option?.name ?? "")
                      .filter((name) => name)}
                    getOptionLabel={(option) => option ?? "-"}
                    value={props?.filterObj?.nameMatch ?? []}
                    onChange={(e, v) => {
                      if (v) {
                        props.setFilterObj((prev) => ({
                          ...prev,
                          nameMatch: v ?? [],
                        }));
                      }
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        placeholder=""
                        className="autocomplete-text-field-class"
                      />
                    )}
                  />
                </div>
              )}
            </th>
            <th>
              Service mode
              <img
                src={
                  (props?.filterObj?.modeNames?.length ?? 0) > 0
                    ? filterApplied
                    : funnelIcon
                }
                style={{ cursor: "pointer" }}
                onClick={() => {
                  setOpenBackdrop(true);
                  setOpenFilter(4);
                }}
              />
              {openFilter === 4 && (
                <div className="filter-div-assigned-plans-table">
                  <Autocomplete
                    style={{
                      width: "300px",
                      maxHeight: "200px",
                      overflowY: "scroll",
                      overflowX: "hidden",
                    }}
                    multiple
                    id="multiple-limit-service-mode"
                    options={[
                      ...new Set(
                        (
                          (props?.data?.allAssignedServicesArray ?? []).map(
                            (service) => service?.serviceModeDetails ?? [],
                          ) ?? [[]]
                        )
                          .flat()
                          .map((mode) => mode?.modeName ?? "")
                          .filter((name) => name),
                      ),
                    ]}
                    getOptionLabel={(option) => option ?? "-"}
                    value={props?.filterObj?.modeNames ?? []}
                    onChange={(e, v) => {
                      if (v) {
                        props.setFilterObj((prev) => ({
                          ...prev,
                          modeNames: v ?? [],
                        }));
                      }
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        placeholder=""
                        className="autocomplete-text-field-class"
                      />
                    )}
                  />
                </div>
              )}
            </th>
            <th>MRP</th>
            <th>Discounted price</th>
            <th>
              Status
              <img
                className="filter-icon-assigned-plans"
                src={props?.filterObj?.status ? filterApplied : funnelIcon}
                onClick={() => {
                  setOpenBackdrop(true);
                  setOpenFilter(1);
                }}
              />
              {openFilter === 1 && (
                <div className="filter-div-assigned-plans-table">
                  <div className="can-be-booked-for-filter">
                    {Object.entries(STATUS_MAP).map(([key, val]) => (
                      <div>
                        <Radio
                          label={key}
                          checked={props?.filterObj?.status == val}
                          onClick={() => {
                            setOpenBackdrop(false);
                            setOpenFilter(-1);
                            props.setFilterObj((prev) => ({
                              ...prev,
                              status: val,
                            }));
                          }}
                        />
                        <label className="label-radio-btn">{key}</label>
                      </div>
                    ))}
                    <Button
                      className="clear-navigo-booked-for"
                      onClick={() => {
                        props.setFilterObj((prev) => ({
                          ...prev,
                          status: null,
                        }));
                      }}
                    >
                      Clear
                    </Button>
                  </div>
                </div>
              )}
            </th>
          </tr>
        </thead>
        <tbody className="animated-box">
          {Boolean(tableData?.length == null || tableData?.length <= 0) && (
            <tr>
              <td colSpan={8}>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    padding: 40,
                  }}
                >
                  <div
                    style={{ textAlign: "center", fontFamily: "Montserrat" }}
                  >
                    No records to show
                  </div>
                  <div style={{ height: "16px" }}></div>
                  <img src={NoRecordsIcon} width={50} height={62} />
                </div>
              </td>
            </tr>
          )}

          {tableData && tableData.length > 0 && (
            <tr>
              <td />
              <td />
              <td />
              <td />
              <td />
              <td />
              <td
                colSpan={8}
                align="right"
                style={{ display: "flex", flexDirection: "row" }}
              >
                <Button
                  onClick={() => {
                    props.goToPrevPage();
                  }}
                  disabled={props?.pageNum <= 1 || loading}
                >
                  <FontIcon className="navigo-count-icon">arrow_left</FontIcon>
                </Button>
                <div style={{ display: "flex", flexDirection: "row" }}>
                  Showing&nbsp;
                  <span
                    style={{
                      color: "#ef7c01",
                      display: "flex",
                      flexDirection: "row",
                    }}
                  >
                    {(props?.pageNum - 1) * props?.pageSize + 1}&nbsp;
                  </span>
                  <span style={{ color: "#ef7c01" }}>-</span>
                  <span
                    style={{
                      color: "#ef7c01",
                      display: "flex",
                      flexDirection: "row",
                    }}
                  >
                    &nbsp;
                    {props?.totalCount > props?.pageNum * props?.pageSize
                      ? props?.pageNum * props?.pageSize
                      : props?.totalCount}
                  </span>
                  <span>&nbsp;&nbsp;of&nbsp;</span>
                  <span>{` ${props?.totalCount}`}</span>
                </div>
                <Button
                  onClick={() => {
                    props.goToNextPage();
                  }}
                  disabled={
                    loading ||
                    props?.pageNum * props?.pageSize > props?.totalCount ||
                    (props?.totalCount > props?.pageNum * props?.pageSize
                      ? props?.pageNum * props?.pageSize
                      : props?.totalCount) == props?.totalCount
                  }
                >
                  <FontIcon>arrow_right</FontIcon>
                </Button>
              </td>
            </tr>
          )}

          {tableData &&
            tableData.map((row, index) => {
              const allModes = getAllModesForService(row?.id);
              const primaryMode = allModes?.[0] ?? row?.serviceModeDetails?.[0];
              const extraModes =
                allModes?.length > 0
                  ? allModes.slice(1)
                  : row?.serviceModeDetails?.slice(1) ?? [];
              const isActive =
                row?.serviceCategory === 1
                  ? row?.groupServiceStatus
                  : primaryMode?.isModeActive == 1;
              return (
                <React.Fragment key={index}>
                  <tr className={`${index > 0 ? "table-row-border" : ""}`}>
                    <td>
                      <Checkbox
                        checked={isRowSelected(row?.id)}
                        onChange={() => {
                          if (props?.onToggleService) {
                            props.onToggleService(row?.id);
                          }
                        }}
                      />
                    </td>
                    <td>{row?.id}</td>
                    <td>{row?.serviceTypeName}</td>
                    <td>{row?.name}</td>
                    <td>{primaryMode?.modeName}</td>
                    <td>{primaryMode?.maxPrice}</td>
                    <td>{primaryMode?.discountedPrice}</td>
                    <td>
                      <div
                        className={`${
                          isActive
                            ? "navigo-appoint-non-select-status-active"
                            : "navigo-appoint-non-select-status-inactive"
                        }`}
                      >
                        <span>{isActive ? "Active" : "Inactive"}</span>
                      </div>
                    </td>
                  </tr>
                  {extraModes?.map((roww, idx) => (
                    <tr key={idx} className="table-row-expanded animated-box">
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td>{roww?.modeName}</td>
                      <td>{roww?.maxPrice}</td>
                      <td>{roww?.discountedPrice}</td>
                      <td>
                        <div
                          className={`${
                            roww?.isModeActive
                              ? "navigo-appoint-non-select-status-active"
                              : "navigo-appoint-non-select-status-inactive"
                          }`}
                        >
                          <span>
                            {roww?.isModeActive == 1 ? "Active" : "Inactive"}
                          </span>
                        </div>
                      </td>
                    </tr>
                  ))}
                </React.Fragment>
              );
            })}
        </tbody>
      </table>
      {openBackdrop && (
        <div
          style={{
            position: "fixed",
            left: 0,
            top: 0,
            width: "100vw",
            height: "100vh",
          }}
          onClick={() => {
            setOpenFilter(-1);
            setOpenBackdrop(false);
          }}
        ></div>
      )}
    </div>
  );
};

export default ExpandableTableSelectableAssignedServices;
